import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMatchsService } from '../../../../services/matchs/api/api-matchs.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-match-table-add-modal',
  templateUrl: './match-table-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class MatchTableAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  name: string = '';
  levelMinimumRequired: number = 0;
  levelExperienceRewardQuantity: number = 0;
  leaguePointRewardQuantity: number = 0;
  hammerRewardQuantity: number = 0;
  creditRewardQuantity1: number = 0;
  creditRewardQuantity2: number = 0;
  creditRewardQuantityDraw: number = 0;
  matchCost: number = 0;
  matchRank: number = 0;
  variantId: number = 0;

  private callbackSaved?: () => void;

  constructor(private apiMatchsService: ApiMatchsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.name = '';
    this.levelMinimumRequired = 0;
    this.levelExperienceRewardQuantity = 0;
    this.leaguePointRewardQuantity = 0;
    this.hammerRewardQuantity = 0;
    this.creditRewardQuantity1 = 0;
    this.creditRewardQuantity2 = 0;
    this.creditRewardQuantityDraw = 0;
    this.matchCost = 0;
    this.matchRank = 0;
    this.variantId = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiMatchsService.addMatchTable(
      this.name,
      this.levelMinimumRequired,
      this.levelExperienceRewardQuantity,
      this.leaguePointRewardQuantity,
      this.hammerRewardQuantity,
      this.creditRewardQuantity1,
      this.creditRewardQuantity2,
      this.creditRewardQuantityDraw,
      this.matchCost,
      this.matchRank,
      this.variantId
    ).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Match table added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding match table : ' + error);
      }
    );
  }
}
